import { Droppable } from "@hello-pangea/dnd";
import React from "react";
import AddReleaseLabelButton from "../AddReleaseLabelButton";
import DraggableReleaseLabel from "./DraggableReleaseLabel";
import DynamicReleaseLabel from "./DynamicReleaseLabel";
import { Label } from "./types";

interface DroppableVersionLabelsProps {
  versionId: number;
  labels: Label[];
  dynamicReleaseLabels: Label[];
  handleDynamicReleaseLabelClick: (id: number) => void;
  isActiveVersion: boolean;
  onAddReleaseLabel: (label: string, versionId: number) => Promise<unknown>;
  setLabelToDelete: React.Dispatch<React.SetStateAction<Label | null>>;
  setIsConfirmationModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const DroppableVersionLabels: React.FC<DroppableVersionLabelsProps> = ({
  versionId,
  labels,
  dynamicReleaseLabels,
  handleDynamicReleaseLabelClick,
  isActiveVersion,
  onAddReleaseLabel,
  setLabelToDelete,
  setIsConfirmationModalOpen,
}) => {
  return (
    <div className="ml-6 flex items-center justify-between">
      <Droppable
        droppableId={`version-${versionId}`}
        direction="horizontal"
        type="RELEASE_LABEL"
      >
        {(provided, snapshot) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            className={`flex flex-wrap gap-1 py-0.5 text-xs ${
              snapshot.isDraggingOver ? "rounded-sm bg-blue-50" : ""
            }`}
          >
            {dynamicReleaseLabels.map((label) => (
              <DynamicReleaseLabel
                key={label.name}
                label={label}
                onClick={handleDynamicReleaseLabelClick}
              />
            ))}
            {labels.map((label, index) => (
              <DraggableReleaseLabel
                key={`${label.name}-${label.id}`}
                label={label}
                index={index}
                isActiveVersion={isActiveVersion}
                onDelete={(label) => {
                  setLabelToDelete(label);
                  setIsConfirmationModalOpen(true);
                }}
              />
            ))}
            {provided.placeholder}
            <div
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              className={`${
                labels.length === 0 ? "opacity-50 group-hover:opacity-100" : ""
              }`}
            >
              <AddReleaseLabelButton
                isEmpty={labels.length === 0}
                onSave={(label) => onAddReleaseLabel(label, versionId)}
              />
            </div>
          </div>
        )}
      </Droppable>
    </div>
  );
};

export default DroppableVersionLabels;
